/**
 * List of options for the RFID Start/Stop types field
 *
 * @namespace tmrDeviceControllerTypes
 * @type {ngConstant}
 */
export const constant = [
  'tmrDeviceControllerTypes',
  {
    PRINT_MANAGER: 'DEVICECONTROLLERTYPES.PRINTER',
    SCANNER_MANAGER: 'DEVICECONTROLLERTYPES.SCANNER',
    CONVEYOR_MANAGER: 'DEVICECONTROLLERTYPES.CONVEYOR',
    XSPAN_MANAGER: 'DEVICECONTROLLERTYPES.XSPAN',
  },
]

/**
 * Translates {@link tmrDeviceControllerTypes}
 *
 * @type {ngRun}
 */
let tmrDeviceControllerTypesRun = /*@ngInject*/ (
  TmrTranslate,
  tmrDeviceControllerTypes
) => TmrTranslate.object(tmrDeviceControllerTypes)

export { tmrDeviceControllerTypesRun as run }
